import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const loadAdsPlacements = createAction("".concat(stateName, "/loadAdsPlacements"));
export const loadAdsSegmentIds = createAction("".concat(stateName, "/loadAdsSegmentIds"));